<template>
	<a itemprop="url" :href="lodging.url" class="title h2">
		<div v-if="showNew" class="newHouseArea">
			<span class="new-label">Ny<div class="newHover">Nyt hos Esmark</div></span>
		</div>
		<template v-if="displaySchema === false">
			{{lodging.postMeta.esAddress1}}
		</template>
		<span v-else itemprop="address" itemscope itemtype="https://schema.org/PostalAddress">
			<span itemprop="streetAddress">{{lodging.postMeta.esAddress1}}</span>
			<meta itemprop="postalCode" :content="lodging.postMeta.esPostalCode" />
			<meta itemprop="addressLocality" :content="lodging.postMeta.esCity" />
			<meta itemprop="addressCountry" content="DK" />
			<meta itemprop="alternateName" :content="lodging.postMeta.esAddress2" />
		</span>
		(<span itemprop="identifier">{{lodging.postMeta.esName}}</span>)
	</a>
</template>

<script>
	export default {
		computed:{
			showNew(){
				return this.lodging.postMeta.daysSince <= 365;
			}
		},
		props: {
			lodging: Object,
			displaySchema: {
				type: Boolean,
				default: false
			}
		}
	}
</script>

<style scoped>

</style>
